/* eslint-disable require-jsdoc */

import {isValid} from '../../../utils/validate';

import {library, icon} from '@fortawesome/fontawesome-svg-core';
import {faFacebook, faTwitter} from '@fortawesome/free-brands-svg-icons';
import {faPhoneAlt} from '@fortawesome/free-solid-svg-icons';

library.add(faPhoneAlt, faFacebook, faTwitter);
const phoneAltIcon = icon({ prefix: 'fas', iconName: 'phone-alt' }).html;
const facebookIcon = icon({ prefix: 'fab', iconName: 'facebook' }).html;
const twitterIcon = icon({ prefix: 'fab', iconName: 'twitter' }).html;

function hasVenueSocial(venue) {
  const hasPhone = isValid(venue.phone);
  const hasFacebook = isValid(venue.facebook);
  const hasTwitter = isValid(venue.twitter);
  return hasPhone && hasFacebook && hasTwitter ? true : false;
}
function getVenuePhoneIcon(phone) {




  // const iconContainer = document.createElement('span');
  // iconContainer.innerHTML = icon({ prefix: 'fas', iconName: 'phoneAlt' }).html;
  

  return `<div class="hearby-grid-item">
              <a href="tel:${phone}" class="hearby-phone-link-mobile hearby-icon
               hearby-social-icon hearby-social-icon-phone-alt" target="_blank">
                <span class="hearby-screen-only">Phone-alt</span>
                ${phoneAltIcon}
              </a> 
            </div>`;
}
function getVenueFacebook(facebook) {
  return `<div class="hearby-grid-item">
            <a href="${facebook}" class="hearby-icon hearby-social-icon
               hearby-social-icon-facebook" target="_blank">
              <span class="hearby-screen-only">Facebook</span>
              ${facebookIcon}
              </a> 
          </div>`;
}
function getVenueTwitter(twitter) {
  return `<div class="hearby-grid-item">
          <a href="${twitter}" class="hearby-icon hearby-social-icon 
            hearby-social-icon-twitter" target="_blank">
            <span class="hearby-screen-only">Twitter</span>
            ${twitterIcon}
          </a>
        </div>`;
}
function getVenueSocial(venue) {
  const v = venue;
  const phone = isValid(v.phone) ? getVenuePhoneIcon(v.phone) : '';
  const facebook = isValid(v.facebook) ? getVenueFacebook(v.facebook) : '';
  const twitter = isValid(v.twitter) ? getVenueTwitter(v.twitter) : '';
  return `<div class="hearby-social">
            <div class="hearby-social-icons-wrapper hearby-grid">
              ${phone}
              ${facebook}
              ${twitter}
            </div>
          </div>`;
}
export {getVenueSocial, hasVenueSocial};
